<div>
  <div class="modal-header">
    <div>
      <i class="mdi mdi-map-marker-multiple"></i>
      <span class="header">Select where test will run</span>
    </div>
    <div class="btn-group">
      <button mat-flat-button (click)="closeModal()" class="save-btn" [disabled]="disableSave()">
        SAVE
      </button>
      <i class="mdi mdi-close close-icon" mat-dialog-close></i>
    </div>
  </div>

  <div class="table-container">
    <mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
      <mat-tab label="Choose by Site">
        <div
          class="device-picker-content device-picker-list"
          *ngIf="isOpened && sites && sites.length > 0 && siteTab"
        >
          <nrwl-site-table
            [selectedSites]="preSelectedSites"
            [sites]="sites"
            [deviceComp]="deviceComp"
            [hidingSiteData]="hidingSiteData"
            [singleSelection]="singleSelection"
            [hidingData]="data.hidingData"
            [testType]="testType"
            [hideResourceUnavailableAgent]="data.hideResourceUnavailableAgent"
          ></nrwl-site-table>
        </div>
        <div
          *ngIf="siteTab && isOpened && (!sites || (sites && sites.length === 0))"
          class="no-record"
        >
          No records found
        </div>
      </mat-tab>
      <mat-tab label="Choose by Device">
        <div
          class="device-picker-content device-picker-list"
          *ngIf="devices && devices.length > 0 && deviceTab"
        >
          <nrwl-device-table
            [selectedDevices]="preSelectedDevices"
            [siteList]="siteList"
            [devices]="devices"
            [siteComp]="siteComp"
            [hidingDeviceData]="hidingDeviceData"
            [singleSelection]="singleSelection"
            [hidingData]="data.hidingData"
            [hidingDeviceType]="data?.hidingDeviceType"
            [testType]="testType"
            [hideResourceUnavailableAgent]="data.hideResourceUnavailableAgent"
          ></nrwl-device-table>
        </div>
        <div *ngIf="deviceTab && (!devices || (devices && devices.length === 0))" class="no-record">
          No records found
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
